import { Component, inject } from '@angular/core';
import { AppStore } from '@core/store/core/app.store';
import { ProgressBar } from 'primeng/progressbar';

@Component({
  selector: 'mp-loader',
  templateUrl: './loader.component.html',
  standalone: true,
  imports: [ProgressBar],
  providers: [],
})
export class LoaderComponent {
  appStore = inject(AppStore);
}
